'use client';

import { createClient } from '@/utils/supabase/client';
import type { User } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';

export default function useUser() {
  const supabase = createClient();

  const {
    data: user,
    isLoading,
    error,
  } = useQuery<User | null>({
    queryKey: ['user'],
    queryFn: async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      return user;
    },
    staleTime: 5 * 60 * 1000, // User data fresh for 5 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    retry: 1, // Only retry once for auth calls
  });

  return {
    user,
    isLoading,
    error,
  };
}
